const miscFood = [
  {
    regNum: 154,
    item: "sunomono - no octopus",
    desc: ""
  },
  {
    regNum: 155,
    item: "miso sauce",
    desc: ""
  },
  {
    regNum: 156,
    item: "small mixed pickles",
    desc: ""
  },
  {
    regNum: 166,
    item: "ochazuke plain",
    desc: ""
  },
  {
    regNum: 167,
    item: "ochazuke, yaki onigiri",
    desc: ""
  },
  {
    regNum: 168,
    item: "ochazuke - extra topping",
    desc: ""
  },
  {
    regNum: 170,
    item: "ikadayaki",
    desc: ""
  },
  {
    regNum: 171,
    item: "raw quail egg",
    desc: "uzura raw"
  },
  {
    regNum: 178,
    item: "umbeboshi",
    desc: "pickled plum"
  },
  {
    regNum: 179,
    item: "yuzu pepper",
    desc: "yuzu kosho"
  },
  {
    regNum: 180,
    item: "chili oil",
    desc: ""
  },
  {
    regNum: 181,
    item: "wasabi",
    desc: ""
  },
  {
    regNum: 299,
    item: "cake fee",
    desc: ""
  },
  {
    regNum: 163,
    item: "yaki nasu",
    desc: ""
  }
]

export default miscFood;